//App state
export const APP_LOADED = 'APP_LOADED';
export const ENABLE_METAMASK = 'ENABLE_METAMASK';
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT';
export const SET_IS_USER_ACCOUNT_SELECTED = 'SET_IS_USER_ACCOUNT_SELECTED';
export const SET_CURRENT_NETWORK = 'SET_CURRENT_NETWORK';

//User actions
export const SET_USER_DETAILS = 'SET_USER_DETAILS';

//Authentication Actions
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const SIGN_OUT = 'SIGN_OUT';


//Profile Actions
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

//Alert Actions
export const ALERT = 'ALERT';

//Transaction States Actions
export const ADD_TRANSACTION_STATE = 'ADD_TRANSACTION_STATE';
export const SET_TRANSACTION_STATE = 'SET_TRANSACTION_STATE';